import Box from "@mui/material/Box";
import { cleanProps } from "../internal/cleanProps";
import type { QuestionRowProps } from "../types";

/** ADR-20261102-h2fd: one question on an H2 section page: 12px beneath it, on top of the section
 * body's 16px gap and each field's own 24px margin. */
export function QuestionRow({ children, testId }: Readonly<QuestionRowProps>) {
  return (
    <Box
      {...cleanProps({ "data-testid": testId })}
      sx={{ display: "flex", flexDirection: "column", minWidth: 0, paddingBottom: "12px" }}
    >
      {children}
    </Box>
  );
}
